import type { AppState } from '@auth0/auth0-react';
import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';

import { config } from '../config/loader.js';

interface Props {
  children?: React.ReactNode;
}

export const Auth0ProviderConfigured: React.FC<Props> = ({ children }) => {
  const onRedirectCallback = (appState?: AppState): void => {
    const returnTo = appState?.returnTo ?? '/';
    window.location.href = returnTo;
  };

  return (
    <Auth0Provider
      domain={config.auth0Domain}
      clientId={config.auth0ClientId}
      cacheLocation="localstorage"
      authorizationParams={{
        audience: config.auth0Audience,
        scope: 'profile email offline_access',
        redirect_uri: window.location.origin + '/auth0-success',
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
      useRefreshTokensFallback
    >
      {children}
    </Auth0Provider>
  );
};
